<template>
    <div class="goodDetail-container">
        <div class="goodDetail-left">
            <div class="goodDetail-intro">
                <a :href="goodsInfo.goods_url" target="_blank" class="good-cover">
                    <img :src="goodsInfo.goods_img_url" alt="">
                </a>
                <div class="good-detail">
                    <div class="d-left">
                        <a :href="goodsInfo.goods_url" target="_blank" class="title text-overflow-2">{{goodsInfo.goods_name}}</a>
                        <p class="line">
                            <span class="tag">
                                抖音浏览量：
                                <span v-if="goodsInfo.view_num">{{goodsInfo.view_num}}</span>
                                <span v-else>0</span>
                            </span>
                            <span class="tag">
                                全网销量：
                                <span v-if="goodsInfo.sales_total">{{goodsInfo.sales_total}}</span>
                                <span v-else>0</span>
                            </span>
                        </p>
                        <p class="line">
                            <span class="tag">
                                直播场次：
                                <span v-if="goodsInfo.live_count">{{goodsInfo.live_count}}</span>
                                <span v-else>0</span>
                            </span>
                            <span class="tag">
                                推广账号数：
                                <span v-if="goodsInfo.promotion_user_account">{{goodsInfo.promotion_user_account}}</span>
                                <span v-else>0</span>
                            </span>
                        </p>
                    </div>
                    <div class="d-right">
                        <strong class="price-now" v-if="goodsInfo.price">&yen; {{goodsInfo.price}}</strong>
                        <strong class="price-now" v-else>&yen; 无</strong>
                        <span class="price-old" v-if="goodsInfo.market_price">原价: {{goodsInfo.market_price}}</span>
                        <span class="price-old" v-else>原价: 无</span>
                    </div>
                </div>
            </div>
            <el-tabs v-model="goodDetailTabs" type="card" class="goodDetail-tabs">
                <el-tab-pane label="商品热度分析" name="hot" :lazy="true">
<!--                    :pageType="pageType"-->
                    <GoodHot />
                </el-tab-pane>
                <el-tab-pane label="抖音推广视频" name="promote">
                    <GoodPromote />
                </el-tab-pane>
                <el-tab-pane label="在售播主分析" name="broadCaster">
                    <GoodBroadCaster />
                </el-tab-pane>
                <el-tab-pane label="商品观众画像" name="audience" :lazy="true">
                    <GoodAudience />
                </el-tab-pane>
            </el-tabs>
        </div>
        <!--右侧帮助中心-->
        <RightHelpList></RightHelpList>
    </div>
</template>

<script>
    import GoodHot from '@/components/goodDetail/GoodHot.vue'
    import GoodPromote from '@/components/goodDetail/GoodPromote.vue'
    import GoodBroadCaster from '@/components/goodDetail/GoodBroadCaster.vue'
    import GoodAudience from '@/components/goodDetail/GoodAudience.vue'
    import RightHelpList from '@/components/helpCenter/RightHelpList.vue'

    export default {
        data() {
            return {
                goodDetailTabs: 'hot',
                detailType: this.$route.query.type || 'hot',
                goodsId: Number(this.$route.query.id) || '',
                goodsInfo: {}
            }
        },
        components: {
            GoodHot,
            GoodPromote,
            GoodBroadCaster,
            GoodAudience,
            RightHelpList
        },
        mounted() {
            this.goodDetailTabs = this.detailType
            this.getOneGoodsInfo()
        },
        methods: {
            getOneGoodsInfo() {
                this.$httpStudent.axiosGetBy(this.$api.getGoodsInfo, {id: this.goodsId}, (res) => {
                    if (res.code === 200) {
                        this.goodsInfo = res.info
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    ::v-deep p {
        margin: 0;
    }
    .goodDetail-container {
        height: 100%;
        display: flex;
        .goodDetail-left {
            width: 1%;
            flex: 1;
            display: flex;
            flex-direction: column;
            .goodDetail-intro {
                display: flex;
                background: #fff;
                padding: 20px;
                .good-cover {
                    width: 130px;
                    height: 130px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
                .good-detail {
                    width: 1%;
                    flex: 1;
                    margin-left: 20px;
                    display: flex;
                    justify-content: space-between;
                    .d-left {
                        width: 1%;
                        flex: 1;
                        .title {
                            font-size: 16px;
                            margin-bottom: 20px;
                            color: #333;
                            &:hover {
                                color: #1E33E3;
                            }
                        }
                        .line {
                            margin-top: 10px;
                            .tag {
                                display: inline-block;
                                color: #999;
                                min-width: 40%;
                                margin-right: 2%;
                            }
                        }
                    }
                    .d-right {
                        margin-left: 100px;
                        .price-now {
                            color: #FF0101;
                            font-size: 18px;
                        }
                        .price-old {
                            color: #666;
                            margin-left: 24px;
                            text-decoration: line-through;
                        }
                    }
                }
            }
            .goodDetail-tabs {
                height: 1%;
                flex: 1;
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                ::v-deep .el-tabs__header {
                    margin-bottom: 0;
                    border-bottom: none;
                    .el-tabs__nav {
                        border-color: transparent;
                        .el-tabs__item {
                            border-color: transparent;
                            height: 50px;
                            line-height: 50px;
                            border-top-left-radius: 6px;
                            border-top-right-radius: 6px;
                            font-size: 16px;
                            color: #858EA6;
                            &.is-active {
                                color: #0824CE;
                                background: #fff;
                            }
                            &:hover {
                                color: #0824CE;
                            }
                        }
                    }
                }
                ::v-deep .el-tabs__content {
                    height: 1%;
                    flex: 1;
                    background: #fff;
                    .el-tab-pane {
                        height: 100%;
                    }
                }
            }
        }
    }
</style>